import { useEffect, useState } from 'react';
import { Design } from '@/types';
import { loadImage } from '@/utils/image/loadImage';
import { getDesignImageUrl } from '@/utils/imageUrls/getDesignImageUrl';

export function useLoadImages(design: Design) {
  const [loadedImages, setLoadedImages] = useState<HTMLImageElement[]>([]);

  useEffect(() => {
    const imagePromises = design.colors.map<Promise<HTMLImageElement>>((color) => {
      const colors = Array(design.colors.length).fill('none');
      colors[color.layer] = 'FFFFFF';
      const url = getDesignImageUrl(design.id, {
        width: 600,
        colors,
      });
      return loadImage(url);
    });
    Promise.all(imagePromises).then(setLoadedImages);
  }, [design]);

  return loadedImages;
}
